// Admin email addresses
export const ADMIN_EMAILS = [
    'bttvn.4t@gmail.com',
    // Thêm admin emails khác ở đây
];

export const isAdmin = (userEmail: string | null | undefined): boolean => {
    if (!userEmail) return false;
    return ADMIN_EMAILS.includes(userEmail.toLowerCase());
};